module.exports = __webpack_public_path__ + "img/base_divers_producteur_local.1c0ebe16.svg";